import { useCallback, useEffect, useState } from "react";
import { getGoogleCalendarUpcoming, type GoogleCalendarUpcomingEvent } from "@/lib/googleCalendarClient";

export function useGoogleCalendarUpcoming(enabled = true) {
  const [events, setEvents] = useState<GoogleCalendarUpcomingEvent[]>([]);
  const [eventsTodayCount, setEventsTodayCount] = useState(0);
  const [linked, setLinked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError("");
    const r = await getGoogleCalendarUpcoming();
    setLoading(false);
    if (!r.ok) {
      setError(r.error);
      setEvents([]);
      setEventsTodayCount(0);
      setLinked(false);
      return;
    }
    setLinked(r.data.linked);
    setEvents(r.data.events ?? []);
    setEventsTodayCount(r.data.events_today_count ?? 0);
  }, [enabled]);

  useEffect(() => {
    void load();
  }, [load]);

  return { events, eventsTodayCount, linked, loading, error, reload: load };
}
